<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>摄像头列表</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="progress-bar">
                <el-input class="search-inpt" placeholder="请输入设备名称" v-model="tableDataName"></el-input>
                <el-button type="primary" class="search-btn" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" class="search-btn" icon="el-icon-plus" @click="addCarme">新增</el-button>
            </div>
            <div class="progress-con">
                <el-table :data="tableDataEnd" ref="tableDataBegin" height="100%" border style="width: 100%;">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80" type="index">
                </el-table-column>
                <el-table-column label="摄像机名称">
                    <template slot-scope="scope">
                    {{ scope.row.name}}
                    </template>
                </el-table-column>
                <el-table-column label="序列号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.serial }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="排序">
                    <template slot-scope="scope">
                    <span>{{ scope.row.sort }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="通道号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.channelNo }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="验证码">
                    <template slot-scope="scope">
                    <span>{{ scope.row.vcode }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.type=='2'">球机</span>
                      <span v-else>枪机</span>
                    </template>
                </el-table-column>
                <el-table-column label="使用类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.useType=='2'">塔吊监控</span>
                      <span v-else-if="scope.row.useType=='3'">大门监控</span>
                      <span v-else-if="scope.row.useType=='1'">普通监控</span>
                      <span v-else>普通监控</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                      <el-button size="mini" type="success" @click="toDecrypt(scope.row)">解密</el-button>
                      <el-button v-if="scope.row.useType=='4'" size="mini" type="warning" @click="toWarnData(scope.row)">预警数据</el-button>
                    </template>
                </el-table-column>
                </el-table>
                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="140px"
                    id="formData"
                    :label-position="labelPosition"
                    >
                    <el-form-item label="名称：">
                        <el-input v-model="addForm.name" placeholder="请输入名称" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="序列号：">
                        <el-input v-model="addForm.serial" placeholder="请输入序列号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码：">
                        <el-input v-model="addForm.vcode" placeholder="请输入验证码" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="通道号：">
                        <el-input v-model="addForm.channelNo" placeholder="请输入通道号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="排序：">
                        <el-input v-model="addForm.sort" placeholder="请输入排序" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="类型：">
                        <el-radio-group v-model="addForm.type">
                          <el-radio label="1">枪机</el-radio>
                          <el-radio label="2" style="margin-left:20px;">球机</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="使用类型：">
                        <el-radio-group v-model="addForm.useType">
                          <el-radio :label="item.value" style="padding:1vh 0;" v-for="(item,index) in useTypes" :key="index">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                     <el-form-item label="算法摄像头地址：" v-if="addForm.useType=='4'">
                      <p style="font-size: 14px;">http://47.103.123.116:17001/noToken/baoSiYanCamera/sms/receiveAlarmServer/cameraMessage</p>
                    </el-form-item>
                    <el-form-item label="算法盒子地址：" v-if="addForm.useType=='4'">
                      <p style="font-size: 14px;">http://47.103.123.116:17001/noToken/huaweiCamera/receiveAlarmServer/cameraMessage</p>
                    </el-form-item>
                    <el-form-item label="摄像头硬件ID：" v-if="addForm.useType=='4'">
                        <el-input v-model="addForm.camId" placeholder="请输入摄像头硬件ID" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" v-model="addForm.remarks"></el-input>
                    </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer" style="margin-top:20px;text-align: center;">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
    data() {
    return {
      tableDataName: '', // 搜索数据名
      tableDataEnd: [], // 设备表单数据
      flag: false, // 搜索数据flag值
      groupId: util.session.get('groupId'),
      type:'',//设备类型 1海康（萤石云）  2大华
      id:'',//硬盘录像机
      addFormVisible:false,
      addForm:{
        id:'',
        monitorId:'',
        projectId:'',
        name:'',
        serial:'',
        vcode:'',
        sort:'',
        channelNo:'',
        type:'1',
        useType:'1',
        camId:'',
      }, // 添加设备表单数组
      labelPosition:'right',
      dataText:"数据加载中...",
      dialogTitle:'',
      useTypes:[],
    }
  },
  mounted() {
    var params = this.$route.params;
    this.type = params.type;
    this.id = params.id;
    this.getData()
    this.getUseType()
  },
  methods: {
   // 获取数据
    getData() {
      var option = {
        pageNum: 1,
        pageSize: 10,
        monitorId: this.id,
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.getListByMonitorId(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            // console.log(resp.data.data.cameraList)
            var list = resp.data.data.cameraList || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = list.length
            if(that.tableDataEnd.length==0){
              that.dataText='暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText='暂无数据'
          }
        },
        function() {}
      )
    },

    //获取使用类型字典 mt_useType
    getUseType(){
      var that = this
      myHttp.getDictByType({
        type:'mt_useType'
      }).then(function(resp){
        if (resp.data.code == '200') {
            that.useTypes = resp.data.data.dictList
            // that.getData()
        }
      })
    },

    // 搜索数据 111
    doFilter() {
      this.currentPage = 1
      this.currentChangePage()
      this.flag = true
    },

    //新增摄像头
    addCarme(){
      this.dialogTitle = '新增设备信息'
      this.addFormVisible = true
      this.addForm.id = ''
      this.addForm.monitorId = this.id
      this.addForm.projectId = this.groupId
      this.addForm.name = ''
      this.addForm.serial = ''
      this.addForm.vcode = ''
      this.addForm.sort = ''
      this.addForm.channelNo = ''
      this.addForm.type = '1'
      this.addForm.useType = '1'
      this.addForm.camId = ''
    },
    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      for(var i in this.addForm){
        this.addForm[i] = row[i]
      }
      // this.addForm = row
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteCamera({
            id: row.id
          })
          .then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },

    //编辑
    sumbitAddRow(formName){
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          delete that.addForm.createDate
          if(that.addForm.id==''){
            myHttp.createCameraInfo(that.addForm).then(function(resp){
              if (resp.data.code == "200") {
                  that.$message.success("添加成功");
                  that.addFormVisible = false;
                  that.getData();
                } else {
                  that.$message.error(resp.data.msg);
                }
            })
          }else if (that.type == "1") {
            //萤石云修改
            myHttp.updateCameraInfo(that.addForm).then(
              function(resp) {
                if (resp.data.code == "200") {
                  that.$message.success("修改成功");
                  that.addFormVisible = false;
                  that.getData();
                } else {
                  that.$message.error(resp.data.msg);
                }
              },
              function() {}
            );
          } else {
            //大华修改
            myHttp.updateCameraInfo(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      });
    },

    ////解密
    toDecrypt(row){
      var that = this
      myHttp.encryptOffMonitor({
        projectId: this.groupId,
        serial:row.serial,
        vcode:row.vcode
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          that.$message.success('解密成功')
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },
    /**
     * 跳转预警页面useType
     */
    toWarnData(row){
      this.$router.push({path:'/huaWarn/'+row.camId})
    },

  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    }
    .progress-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .search-btn {
        margin-left: 20px;
    }

    .search-inpt {
        margin-left: 20px;
        width: 200px;
    }

    .progress-con {
        width: 100%;
        padding: 40px;
        background: #fff;
        height: calc(100% - 80px);
    }
</style>
<style>
@import '../../../assets/css/common.css';
</style>